import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ClientState = {
  name: string;
  phoneNumber: string;
  contactNumber?: string;
};

export const initialClientState: ClientState = {
  name: '',
  phoneNumber: '',
  contactNumber: '',
};

const clientSlice = createSlice({
  name: 'client',
  initialState: initialClientState,
  reducers: {
    setClientData(state, action: PayloadAction<Partial<ClientState>>) {
      Object.assign(state, action.payload);
    },
    resetClientState() {
      return initialClientState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('RESET_CLIENT_STATE', () => initialClientState);
  },
});

export const { setClientData, resetClientState } = clientSlice.actions;
export default clientSlice.reducer;
